<template>
    <v-container fluid>
        <v-card class="pa-4">
            <v-card-title class="headline mb-4">
                Изменить параметр биллинга
            </v-card-title>
            <v-card-text>
                <v-form v-model="formValid" @submit.prevent="submitForm">

                    <div class="mb-6">
                        <div class="text-subtitle-1 font-weight-medium mb-2">Информация о грузе:</div>
                        <div><strong>Вид:</strong> {{ vidName || 'Не указано' }}</div>
                        <div><strong>Колонка:</strong> {{ columnName || 'Не указано' }}</div>
                    </div>
                    <!-- Тариф -->
                    <v-text-field v-model="billingParameterEditingPart.tarif" label="Тариф (руб)" placeholder="0.00"
                        type="number" step="0.01" :rules="[tarifRule]" class="mb-4" />

                    <!-- Дата начала - в Vue 2 используем v-menu с v-date-picker -->
                    <v-menu v-model="dateMenu" :close-on-content-click="true" transition="scale-transition" offset-y
                        min-width="auto" class="mb-4">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="dateBeginFormatted" label="Дата начала" prepend-icon="mdi-calendar"
                                readonly v-bind="attrs" v-on="on" :rules="[dateRule]" required clearable
                                @click:clear="dateBegin = null"></v-text-field>
                        </template>
                        <v-date-picker v-model="billingParameterEditingPart.dateBegin" no-title scrollable
                            locale="ru-ru"></v-date-picker>
                    </v-menu>

                    <!-- Кнопки с правильным расположением -->
                    <v-row class="mt-4">
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn @click="cancel" class="mr-2" color="grey">
                                Отмена
                            </v-btn>
                            <v-btn type="submit" :disabled="!formValid" color="primary">
                                Сохранить
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'EditBillingParameter',
    data() {
        return {
            billingParameterID: null,
            cargoTypeID: null,
            billingParameterEditingPart: {
                dateBegin: '', // Добавьте начальное значение
                tarif: ''      // Добавьте начальное значение
            },
            vidName: '',
            columnName: '',
            formValid: false,
            dateMenu: false, // Добавьте для v-menu
        }
    },
    computed: {
        dateBeginFormatted() {
            if (!this.billingParameterEditingPart.dateBegin) return '';

            const [year, month, day] = this.billingParameterEditingPart.dateBegin.replace('T00:00:00', '').split('-');
            return `${day}.${month}.${year}`;
        }
    },
    methods: {
        requiredRule(value) {
            return !!value || 'Это поле обязательно для заполнения';
        },

        tarifRule(value) {
            if (value === null || value === '' || value === undefined) {
                return 'Тариф обязателен для заполнения';
            }
            if (isNaN(value)) {
                return 'Тариф должен быть числом';
            }
            if (parseFloat(value) < 0) {
                return 'Тариф не может быть отрицательным';
            }
            return true;
        },

        dateRule(value) {
            return !!value || 'Дата начала обязательна';
        },

        async submitForm() {
            if (!this.formValid) {
                this.$toast.error('Пожалуйста, заполните все обязательные поля корректно');
                return;
            }

            // Исправьте формирование данных
            const formData = {
                value: parseFloat(this.billingParameterEditingPart.tarif), // Используйте правильное свойство
                dateBegin: this.billingParameterEditingPart.dateBegin // Используйте правильное свойство
            };

            console.log('Sending data:', formData);

            await this.axios.put(`/Billing/bill-tarif-detal/${this.billingParameterID}`, formData);

            this.$router.push(`/settings/cargoTypes/BillingParameters/${this.cargoTypeID}`);
        },

        cancel() {
            this.$router.back();
        }
    },
    async created() {
        try {
            this.billingParameterID = this.$route.params.id;

            const response = await this.axios.get(`/Billing/bill-tarif-detal/${this.billingParameterID}`);
            const billingParameter = response.data; // Добавьте .data

            // Исправьте присваивание
            this.billingParameterEditingPart.tarif = billingParameter.value; // Поле Value, а не tarif
            this.billingParameterEditingPart.dateBegin = billingParameter.dateBegin;
            this.cargoTypeID = billingParameter.cargoTypeID;
            this.vidName = billingParameter.billColumn.billColumnVid.name;
            this.columnName = billingParameter.billColumn.name;

        } catch (error) {
            console.error('Error loading data:', error);
            this.$toast.error('Ошибка загрузки данных');
        }
    }
}
</script>